import { InformationFilled } from "@carbon/icons-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { FolderTrashMenuActions } from "../constants/lib.constants";
import { IContent } from "../types/lib.types";

interface IDialogConfirmDeleteContentProps {
  isShow: boolean;
  content?: Partial<IContent> | null;
  onOpenChange?: (val: boolean) => void;
  onRejectContent?: () => void;
  onAcceptContent?: () => void;
  type: FolderTrashMenuActions;
}

const DialogConfirmDeleteContent = ({
  isShow,
  content,
  onOpenChange,
  onAcceptContent,
  onRejectContent,
  type,
}: IDialogConfirmDeleteContentProps) => {
  const contentName = content?.name ?? "nội dung";

  const dialogTitle = (() => {
    switch (type) {
      case FolderTrashMenuActions.Restore:
        return "Khôi phục nội dung";
      case FolderTrashMenuActions.Delete:
        return "Xóa vĩnh viễn";
      case FolderTrashMenuActions.DeleteAll:
        return "Xóa vĩnh viễn tất cả";
      default:
        return "Xác nhận thao tác";
    }
  })();

  const descriptionContent = (() => {
    switch (type) {
      case FolderTrashMenuActions.Restore:
        return (
          <>
            <span className="font-medium">{contentName}</span> sẽ được khôi phục
            và xuất hiện trong thư viện của bạn.
          </>
        );
      case FolderTrashMenuActions.Delete:
        return (
          <>
            Bạn sẽ không thể khôi phục{" "}
            <span className="font-medium">{contentName}</span> trong tương lai.
          </>
        );
      case FolderTrashMenuActions.DeleteAll:
        return (
          <>
            Tất cả nội dung trong thùng rác sẽ bị xóa vĩnh viễn. Bạn không thể
            hủy hành động này sau khi thực hiện.
          </>
        );
      default:
        return "Vui lòng xác nhận thao tác này.";
    }
  })();

  return (
    <Dialog
      open={isShow}
      onOpenChange={onOpenChange}
      onEnterKeyPressWhenOpen={onAcceptContent}
    >
      <DialogContent className="w-[600px] max-w-full bg-white">
        <div className="flex flex-row gap-4">
          <div className="h-fit rounded-full bg-[#FEF3F2] p-2">
            <div className="rounded-full bg-[#FEE4E2] p-2">
              <InformationFilled className="h-[24px] w-[24px] text-[#D92D20]" />
            </div>
          </div>
          <div className="w-full">
            <DialogHeader className="items-start space-y-2 text-left">
              <DialogTitle className="text-lg font-semibold">
                {dialogTitle}
              </DialogTitle>
              <DialogDescription className="text-sm text-secondary-600">
                {descriptionContent}
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-end space-x-2 pt-4">
              <Button
                variant="outline"
                onClick={onRejectContent}
              >
                Hủy bỏ
              </Button>
              <Button
                variant={
                  type === FolderTrashMenuActions.DeleteAll
                    ? "destructive"
                    : "secondary"
                }
                onClick={onAcceptContent}
              >
                {type === FolderTrashMenuActions.DeleteAll
                  ? "Xóa vĩnh viễn"
                  : "Xác nhận"}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DialogConfirmDeleteContent;
